import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch } from './client';
import { keys } from './keys';

const EntitySchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export function useEntities() {
  return useQuery({
    queryKey: keys.entities(),
    queryFn: () => apiFetch('/api/entities', z.array(EntitySchema.passthrough())),
  });
}

export function useCreateEntity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string }) =>
      apiFetch('/api/entities', EntitySchema, {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: keys.entities() }),
  });
}
